/* eslint-disable react/prop-types */
/* eslint-disable */
import React, { useState, useEffect, useRef } from 'react'
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  // TextField,
  Button,
  FormControl,
  // InputLabel,
  // Select,
  // MenuItem,
  Grid,
  Typography,
} from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import {
  validateAndGetAccountLevel1,
  validateAndGetAccountLevel2,
  validateAndGetAccountLevel3,
} from '../../../services/skpApi'
import { validateAccountData } from '../../../services/common/accountValidateApi'
import { getUser } from '../../../redux/global'
import { successToast } from '../../../common/functions'
import * as gdeTransactions from '../../../services/firestore/gdeTransactions'
import * as constants from '../../../irmlib/src/common/constants'
import { MultiSelectWithCheckboxes, Select, TextField } from '../../../irmlib/src/components/FormControls'
import { useFormPageHandler } from '../../../irmlib/src/hooks'

const defaultSelectOption = {
  value: constants.defaultSelect,
  label: constants.defaultSelect,
}

const SELECT_WMS_INSTANCE = 0
const SELECT_WMS_REGION = 1
const SELECT_ACOUNT_LEVEL1 = 2
const SELECT_ACOUNT_LEVEL2 = 3
const SELECT_ACOUNT_LEVEL3 = 4
const APPLICABLE_FOR = 5
const EXCLUSION_REASON = 6
const OTHER_REASON = 7

const EXCLUSION_FLAG_TYPES = [
  { field: 'isSC', type: 'Smart Catalog' },
  { field: 'isEdge', type: 'Local AI' },
  { field: 'offshoreExcl', type: 'Offshore Exclusion' },
]

const buildExclusionTypesFromEditData = (editData) => {
  const selected = EXCLUSION_FLAG_TYPES
    .filter(({ field }) => editData?.[field])
    .map(({ type }) => type)

  if (selected.length === EXCLUSION_FLAG_TYPES.length) {
    return ['all', ...selected]
  }
  return selected
}

const getService = async (setState) => {
  const getObject = {
  }
  return Promise.resolve(getObject)
}

const AddCustomerModal = ({ open, onClose, onAddCustomer, isEditMode = false, editData = null }) => {
  const { t } = useTranslation()
  const [customerId, setCustomerId] = useState('')
  const [accountLevel2, setAccountLevel2] = useState('')
  const [accountLevel3, setAccountLevel3] = useState('')
  const [loading, setLoading] = useState(false)
  const [skpInstance, setSkpInstance] = useState('')
  const [selectedWms, setSelectedWms] = useState('SKP')
  const [selectedWmsRegion, setSelectedWmsRegion] = useState('')
  const [wmsInstances, setWmsInstances] = useState([defaultSelectOption])
  const [wmsRegions, setWmsRegions] = useState([])
  const [errorMessage, setErrorMessage] = useState('')
  const [country, setCountry] = useState('')
  const [exclusionType, setExclusionType] = useState([])
  const [appOptions, setAppOptions] = useState([])
  const [exclusionReasonOptions, setExclusionReasonOptions] = useState([])
  const [otherReasonLength, setOtherReasonLength] = useState(0)
  const [exclusionReason, setExclusionReason] = useState('')
  const [otherReason, setOtherReason] = useState('')
  const { workerId } = getUser()
  
  // Refs for form controls
  const refLocalBusyCursor = useRef(null)

  const isUpdatingRef = useRef(false)

  const formTemplate = [
    {
      label: 'Search.wms',
      fieldKey: 'wmsInstance',
      defaultValue: selectedWms || constants.defaultSelect,
      isRequired: true
    },
    {
      label: 'Search.wmsRegion',
      fieldKey: 'wmsRegion',
      defaultValue: constants.defaultSelect,
      isRequired: true
    },
    {
      label: 'templates.accountLevelOne',
      fieldKey: 'accountLevel1',
      defaultValue: '',
      isRequired: true
    },
    {
      label: 'templates.accountLevelTwo',
      fieldKey: 'accountLevel2',
      defaultValue: '',
    },
    {
      label: 'templates.accountLevelThree',
      fieldKey: 'accountLevel3',
      defaultValue: '',
    },
    {
      label: 'Search.applicableFor',
      fieldKey: 'applicableFor',
      defaultValue: [],
      isRequired: true
    },
    {
      label: 'Search.exclusionReason',
      fieldKey: 'exclusionReason',
      defaultValue: '',
      isRequired: true
    },
    {
      label: 'Search.otherReason',
      fieldKey: 'otherReason',
      defaultValue: '',
      isRequired: true
    }
  ]

  useEffect(() => {
    if (open) {
      getSkpInstance()
      if (isEditMode) {
        getWmsInstancesForEdit()
      } else {
        getWmsInstances()
      }
      getCustConfig()
      
      if (isEditMode && editData) {
        // Pre-populate fields for edit mode
        setCustomerId(editData.accountLevel1 || '')
        setAccountLevel2(editData.accountLevel2 || '')
        setAccountLevel3(editData.accountLevel3 || '')
        setSelectedWms(editData.wmsInstance || 'SKP')
        setSelectedWmsRegion(editData.wmsRegion || '')
        
        const exclusionTypes = buildExclusionTypesFromEditData(editData)
        setExclusionType(exclusionTypes)
        
        // Set form field values after a short delay to ensure refs are ready
        setTimeout(() => {
          if (arrRefs[SELECT_WMS_INSTANCE]?.current) {
            arrRefs[SELECT_WMS_INSTANCE].current.setValue(editData.wmsInstance || 'SKP')
          }
          if (arrRefs[SELECT_WMS_REGION]?.current && editData.wmsInstance === 'ONEIL') {
            arrRefs[SELECT_WMS_REGION].current.setValue(editData.wmsRegion || '')
          }
          if (arrRefs[SELECT_ACOUNT_LEVEL1]?.current) {
            arrRefs[SELECT_ACOUNT_LEVEL1].current.setValue(editData.accountLevel1 || '')
          }
          if (arrRefs[SELECT_ACOUNT_LEVEL2]?.current) {
            arrRefs[SELECT_ACOUNT_LEVEL2].current.setValue(editData.accountLevel2 || '')
          }
          if (arrRefs[SELECT_ACOUNT_LEVEL3]?.current) {
            arrRefs[SELECT_ACOUNT_LEVEL3].current.setValue(editData.accountLevel3 || '')
          }
          if (arrRefs[APPLICABLE_FOR]?.current) {
            arrRefs[APPLICABLE_FOR].current.setValue(exclusionTypes)
          }
        }, 100)
      } else {
        // Reset for add mode
        setExclusionType([])
        setExclusionReason('')
        setOtherReason('')
        setOtherReasonLength(0)
        setTimeout(() => {
          if (arrRefs[EXCLUSION_REASON]?.current) {
            arrRefs[EXCLUSION_REASON].current.setValue('')
          }
          if (arrRefs[OTHER_REASON]?.current) {
            arrRefs[OTHER_REASON].current.setValue('')
          }
        }, 0)
      }
      isUpdatingRef.current = false
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, isEditMode, editData])

  // Handle exclusion reason after config is loaded
  useEffect(() => {
    if (isEditMode && editData && exclusionReasonOptions.length > 0) {
      const exceptionValue = editData.exception || ''
      
      // Check if exception value matches any config option
      const matchingOption = exclusionReasonOptions.find(opt => opt.value === exceptionValue)
      
      if (matchingOption) {
        // Value matches config, select it
        setExclusionReason(exceptionValue)
        setOtherReason('')
        setOtherReasonLength(0)
        setTimeout(() => {
          if (arrRefs[EXCLUSION_REASON]?.current) {
            arrRefs[EXCLUSION_REASON].current.setValue(exceptionValue)
          }
          if (arrRefs[OTHER_REASON]?.current) {
            arrRefs[OTHER_REASON].current.setValue('')
          }
        }, 0)
      } else if (exceptionValue) {
        // Value doesn't match config, select "Other" and put value in other reason field
        setExclusionReason('Other')
        setOtherReason(exceptionValue)
        setOtherReasonLength(exceptionValue.length)
        setTimeout(() => {
          if (arrRefs[EXCLUSION_REASON]?.current) {
            arrRefs[EXCLUSION_REASON].current.setValue('Other')
          }
          if (arrRefs[OTHER_REASON]?.current) {
            arrRefs[OTHER_REASON].current.setValue(exceptionValue)
          }
        }, 0)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [exclusionReasonOptions, isEditMode, editData])

  const handleApplicableForChange = (value) => {
    if (isUpdatingRef.current) {
      return
    }

    try {
      // Ensure value is an array
      const data = Array.isArray(value) ? [...value] : (value ? [value] : [])
      
      // Safety check: ensure appOptions is loaded
      if (!appOptions || appOptions.length === 0) {
        setExclusionType(data)
        return
      }

      const allValue = 'all'
      
      // Get all exclusion type values except 'all' (smartCatalog, EdgeAI, etc.)
      const exclusionTypeValues = appOptions
        .filter(opt => opt && opt.value && opt.value !== 'all')
        .map(opt => opt.value)
        .filter(Boolean)

      if (exclusionTypeValues.length === 0) {
        setExclusionType(data)
        return
      }

      const currentValue = exclusionType || []
      const wasAllSelected = currentValue.includes(allValue)
      const isAllSelected = data.includes(allValue)

      // Get currently selected individual options (excluding 'all')
      const currentSelectedTypes = currentValue.filter(v => v !== allValue && exclusionTypeValues.includes(v))
      const newSelectedTypes = data.filter(v => v !== allValue && exclusionTypeValues.includes(v))

      let newValue = []

      // Case 1: User just selected "ALL"
      if (isAllSelected && !wasAllSelected) {
        newValue = [allValue, ...exclusionTypeValues]
      }
      // Case 2: User just unselected "ALL" (directly unchecked ALL checkbox)
      else if (!isAllSelected && wasAllSelected) {
        newValue = []
      }
      // Case 3: User unselected one of the exclusion types while ALL was selected
      else if (wasAllSelected && newSelectedTypes.length < currentSelectedTypes.length) {
        newValue = newSelectedTypes
      }
      // Case 4: User selected/deselected individual options (ALL was not involved)
      else {
        const allTypesSelected = exclusionTypeValues.length > 0 && exclusionTypeValues.every(val => newSelectedTypes.includes(val))
        if (allTypesSelected && !isAllSelected) {
          newValue = [allValue, ...newSelectedTypes]
        } else {
          newValue = data
        }
      }
      // Remove duplicates and ensure it's a valid array
      newValue = [...new Set(newValue)].filter(Boolean)
      // Only update if the value actually changed
      const currentSorted = [...(currentValue || [])].sort()
      const newSorted = [...newValue].sort()
      
      if (JSON.stringify(currentSorted) !== JSON.stringify(newSorted)) {
        isUpdatingRef.current = true
        setExclusionType(newValue)
        
        // Update the component value
        setTimeout(() => {
          try {
            if (arrRefs[APPLICABLE_FOR].current) {
              arrRefs[APPLICABLE_FOR].current.setValue(newValue)
            }
          } catch (error) {
            console.error('Error updating exclusion type ref:', error)
          } finally {
            isUpdatingRef.current = false
          }
        }, 0)
      }
    } catch (error) {
      console.error('Error in handleApplicableForChange:', error)
      // Fallback: just set the value as-is to prevent breaking
      setExclusionType(Array.isArray(value) ? value : [])
      isUpdatingRef.current = false
    }
  }

  const handleExclusionReasonChange = (value) => {
    // Update state to trigger re-render
    setExclusionReason(value || '')
    // Just clear other reason if not "other"
    if (value && value.toLowerCase() !== 'other') {
      setTimeout(() => {
        if (arrRefs[OTHER_REASON]?.current) {
          arrRefs[OTHER_REASON].current.setValue('')
          setOtherReasonLength(0)
        }
      }, 0)
    } else if (value && value.toLowerCase() === 'other') {
      // When switching to "other", sync the length if there's already a value
      setTimeout(() => {
        if (arrRefs[OTHER_REASON]?.current) {
          const currentValue = arrRefs[OTHER_REASON].current.getValue() || ''
          setOtherReasonLength(currentValue.length)
        }
      }, 0)
    }
  }

  const handleOtherReasonChange = (value) => {
    const val = value || ''
    if (val.length <= 50) {
      setOtherReasonLength(val.length)
    } else {
      setOtherReasonLength(50)
    }
  }

  const getSkpInstance = async () => {
    try {
      const workerDetailsGde = await gdeTransactions.getWorkerRoleGde(workerId)
      const workerDetails = await gdeTransactions.getWorkerDetails(workerId)
      const countryValue = workerDetailsGde?.gdeCountry || workerDetails?.country
      setCountry(countryValue)
      const doc = await gdeTransactions.getCountrySkpInstance(countryValue)
      doc?.docs?.forEach((doc) => {
        setSkpInstance(doc?.data()?.skpInstance || '')
      })
    } catch (error) {
      console.error('Error getting SKP instance:', error)
    }
  }

  const [arrRefs, data] = useFormPageHandler({
    formTemplate,
    service: getService,
    busyOverride: refLocalBusyCursor,
  })

  const getCustConfig = async () => {
    const [, , , , , , , , , , , custExclusionType, custExclusionReason] = await gdeTransactions.getGdeConfig()
    const appOpt = []
    const exclusionOpt = []
    const custExclusionTypeData = Object.entries(custExclusionType).map(([key, value]) => ({ value: value.name, label: value.name }))
    const custExclusionReasonData = Object.entries(custExclusionReason).map(([key, value]) => ({ value: value.name, label: value.name }))
    exclusionOpt.push(...custExclusionReasonData)
    appOpt.push({ value: 'all', label: 'ALL' })
    appOpt.push(...custExclusionTypeData)
    appOpt.push({ value: 'Offshore Exclusion', label: 'Offshore Exclusion' })
    setAppOptions(appOpt)
    setExclusionReasonOptions(exclusionOpt)
  }

  const getWmsInstances = async () => {
    const countryCode =
      (await gdeTransactions.getWorkerRoleGde(workerId))?.gdeCountryCode ||
      (await gdeTransactions.getWorkerDetails(workerId))?.countryCode
    const doc = await gdeTransactions.getSkpInstance(countryCode)
    const wmsList = []
    if (doc && 'skp' in doc) {
      const skpInstance = doc.skp.instances[0]
      setSelectedWmsRegion(skpInstance)
      if (skpInstance !== undefined) {
        wmsList.push({
          value: 'SKP',
          label: 'SKP',
        })
      }
    }
    if (doc && 'oneil' in doc) {
      const oneilInstance = doc.oneil.instances
      const instances = oneilInstance.map((key) => ({
        value: key,
        label: key,
      }))
      setWmsRegions(instances)
      if (instances?.length > 0) {
        wmsList.push({
          value: 'ONEIL',
          label: 'ONEIL',
        })
      }
    }
    setWmsInstances(wmsList)
  }

  const getWmsInstancesForEdit = async () => {
    const snapshot = await gdeTransactions.getCountries()
    const wmsList = []
    const allOneilInstances = []
    const seenOneil = new Set()
    snapshot?.docs?.forEach((docSnap) => {
      const wms = docSnap.data()?.wms
      if (wms?.skp?.instances?.length && !wmsList.some((item) => item.value === 'SKP')) {
        wmsList.push({ value: 'SKP', label: 'SKP' })
      }
      if (wms?.oneil?.instances?.length) {
        if (!wmsList.some((item) => item.value === 'ONEIL')) {
          wmsList.push({ value: 'ONEIL', label: 'ONEIL' })
        }
        wms.oneil.instances.forEach((inst) => {
          if (!seenOneil.has(inst)) {
            seenOneil.add(inst)
            allOneilInstances.push({ value: inst, label: inst })
          }
        })
      }
    })
    setWmsRegions(allOneilInstances)
    setWmsInstances(wmsList.length > 0 ? wmsList : [defaultSelectOption])
  }

  const selectWms = (value) => {
    setSelectedWms(value)
  }

  const selectOneil = (value) => {
    if (value) {
      setSelectedWmsRegion(value)
    }
  }

  const accountLevelValidation = async() => {
    setLoading(true)
    const accntLvl1 = customerId.trim()
    const accntLvl2 = accountLevel2.trim()
    const accntLvl3 = accountLevel3.trim()
    const result = await validateAccountData(country, selectedWms, selectedWmsRegion, accntLvl1, accntLvl2, accntLvl3)
    if (result === 'success') {
      onAddCustomer({
        accountLevel1: customerId.trim().toUpperCase(),
        accountLevel2: accountLevel2.trim().toUpperCase(),
        accountLevel3: accountLevel3.trim().toUpperCase(),
        wmsInstance: selectedWms,
        wmsRegion: selectedWmsRegion,
        exclusionType: exclusionType,
        exclusionReason: arrRefs[EXCLUSION_REASON]?.current?.getValue() || '',
        otherReason: arrRefs[OTHER_REASON]?.current?.getValue() || '',
      })
      if (!isEditMode) {
        successToast({
          message: t('toast.customerFieldsSaved'),
          title: t('toast.success'),
          autoHideDuration: 3000,
          isBlocking: false,
        })
      }
      handleClose()
    } else {
      let errorMsg
      if (typeof result === 'string') {
        errorMsg = `API Error: ${result}`
      } else if (typeof result === 'object') {
        if (!result?.errors?.length) {
          errorMsg = `Error: ${'unknown Error'}`
        } else {
          errorMsg = `Error: ${result?.errors[0]?.error}`
        }
      }
      setErrorMessage(errorMsg)
    }
    setLoading(false)
  }

  const handleValidate = async () => {
    setErrorMessage('')
    if (!isEditMode && !customerId.trim()) {
      setErrorMessage(t('toast.cantEmpty'))
      return
    } else if (selectedWms === 'ONEIL' && arrRefs[SELECT_WMS_REGION]?.current?.getValue() === constants.defaultSelect) {
      arrRefs[SELECT_WMS_REGION].current.setErrorMsg('Required', true)
      return
    } else if (!isEditMode && arrRefs[APPLICABLE_FOR]?.current?.getValue()?.length === 0) {
      arrRefs[APPLICABLE_FOR].current.setErrorMsg('Required', true)
      return
    } else if (arrRefs[EXCLUSION_REASON]?.current?.getValue() === '') {
      arrRefs[EXCLUSION_REASON].current.setErrorMsg('Required', true)
      return
    } else if (exclusionReason?.toLowerCase() === 'other' && arrRefs[OTHER_REASON]?.current?.getValue() === '') {
      arrRefs[OTHER_REASON].current.setErrorMsg('Required', true)
      return
    }

    if (!isEditMode && !skpInstance && selectedWms === 'SKP') {
      setErrorMessage(
        t('toast.skpInstanceNotConfigured')
      )
      return
    }

    if (isEditMode) {
      // For edit mode, skip validation and directly save
      onAddCustomer({
        accountLevel1: customerId.trim().toUpperCase(),
        accountLevel2: accountLevel2.trim().toUpperCase(),
        accountLevel3: accountLevel3.trim().toUpperCase(),
        wmsInstance: selectedWms,
        wmsRegion: selectedWmsRegion,
        exclusionType: exclusionType,
        exclusionReason: arrRefs[EXCLUSION_REASON]?.current?.getValue() || '',
        otherReason: arrRefs[OTHER_REASON]?.current?.getValue() || '',
      })
      handleClose()
      return
    }

    if (selectedWms === 'ONEIL') {
      await accountLevelValidation()
    } else {
      setLoading(true)
      try {
        const system = skpInstance

        const result1 = await validateAndGetAccountLevel1(
          system,
          customerId.trim()
        )
        if (!result1.success) {
          setErrorMessage(
            result1.error || t('toast.invalidCustomer')
          )
          setLoading(false)
          return
        }

        let result2 = { success: true }
        if (accountLevel2.trim()) {
          result2 = await validateAndGetAccountLevel2(
            system,
            customerId.trim(),
            accountLevel2.trim()
          )
          if (!result2.success) {
            setErrorMessage(result2.error || t('toast.invalidAccountLevel2'))
            setLoading(false)
            return
          }
        }

        let result3 = { success: true }
        if (accountLevel3.trim()) {
          result3 = await validateAndGetAccountLevel3(
            system,
            customerId.trim(),
            accountLevel2.trim(),
            accountLevel3.trim()
          )
          if (!result3.success) {
            setErrorMessage(result3.error || t('toast.invalidAccountLevel3'))
            setLoading(false)
            return
          }
        }

        onAddCustomer({
          accountLevel1: customerId.trim().toUpperCase(),
          accountLevel2: accountLevel2.trim().toUpperCase(),
          accountLevel3: accountLevel3.trim().toUpperCase(),
          wmsInstance: selectedWms,
          wmsRegion: selectedWmsRegion,
          exclusionType: exclusionType,
          exclusionReason: arrRefs[EXCLUSION_REASON]?.current?.getValue() || '',
          otherReason: arrRefs[OTHER_REASON]?.current?.getValue() || '',
        })
        successToast({
          message: t('toast.customerFieldsSaved'),
          title: t('toast.success'),
          autoHideDuration: 3000,
          isBlocking: false,
        })
        handleClose()
      } catch (error) {
        console.error('Validation error:', error)
        setErrorMessage(t('toast.validationError'))
      } finally {
        setLoading(false)
      }
    }
  }

  const handleClose = () => {
    if (!isEditMode) {
      setCustomerId('')
      setAccountLevel2('')
      setAccountLevel3('')
      setSelectedWms('SKP')
      setSelectedWmsRegion('')
    }
    setErrorMessage('')
    if (!isEditMode) {
      setExclusionType([])
      setExclusionReason('')
      setOtherReason('')
      setOtherReasonLength(0)
      setTimeout(() => {
        if (arrRefs[EXCLUSION_REASON]?.current) {
          arrRefs[EXCLUSION_REASON].current.setValue('')
        }
        if (arrRefs[OTHER_REASON]?.current) {
          arrRefs[OTHER_REASON].current.setValue('')
        }
      }, 0)
    }
    isUpdatingRef.current = false
    onClose()
  }

  const handleAccountLevel1Change = (e) => {
    const custID = arrRefs[SELECT_ACOUNT_LEVEL1]?.current?.getValue()
    if (custID) {
      setCustomerId(custID.toUpperCase())
    } else {
      setCustomerId(e.target.value.toUpperCase())
    }
    if (e.key === 'Enter') {
      handleValidate()
    }
  }

  const handleAccountLevel2Change = (e) => {
    const accntLvl2 = arrRefs[SELECT_ACOUNT_LEVEL2]?.current?.getValue()
    if (accntLvl2) {
      setAccountLevel2(accntLvl2.toUpperCase())
    } else {
      setAccountLevel2(e.target.value.toUpperCase())
    }
  }

  const handleAccountLevel3Change = (e) => {
    const accntLvl3 = arrRefs[SELECT_ACOUNT_LEVEL3]?.current?.getValue()
    if (accntLvl3) {
      setAccountLevel3(accntLvl3.toUpperCase())
    } else {
      setAccountLevel3(e.target.value.toUpperCase())
    }
  }

  return (
    <Dialog
      open={open} 
      onClose={(event, reason) => {
        if (reason === 'backdropClick') return
        if (reason === 'escapeKeyDown') return
        onClose()
      }}
      PaperProps={{
        style: {
          maxWidth: "650px",
          width: "100%",
        },
      }}
      disableEnforceFocus>
      <DialogTitle>{isEditMode ? t('templates.edit'): t('dialogs.addNewCustomer')}</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={4}>
            <FormControl fullWidth margin='normal'>
              <Select
                value={selectedWms}
                onChange={selectWms}
                data={data}
                items={wmsInstances}
                fieldTemplate={formTemplate[SELECT_WMS_INSTANCE]}
                ref={arrRefs[SELECT_WMS_INSTANCE]}
                noTranslateItems
                noTranslate={true}
                disabled={isEditMode}
              />
            </FormControl>
          </Grid>
          {selectedWms === 'ONEIL' && (
            <Grid item xs={12} sm={4}>
              <FormControl fullWidth margin='normal'>
                <Select
                  data={data}
                  items={wmsRegions}
                  value={selectedWmsRegion}
                  fieldTemplate={formTemplate[SELECT_WMS_REGION]}
                  ref={arrRefs[SELECT_WMS_REGION]}
                  onChange={selectOneil}
                  noTranslateItems
                  noTranslate={true}
                  disabled={isEditMode}
                />
              </FormControl>
            </Grid>
          )}
          <Grid item xs={12} sm={4}>
            <TextField
              fullWidth
              margin='normal'
              value={customerId}
              data={data}
              onKeyUp={handleAccountLevel1Change}
              fieldTemplate={formTemplate[SELECT_ACOUNT_LEVEL1]}
              ref={arrRefs[SELECT_ACOUNT_LEVEL1]}
              noTranslateItems
              noTranslate={true}
              disabled={isEditMode}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              fullWidth
              margin='normal'
              data={data}
              value={accountLevel2}
              onKeyUp={handleAccountLevel2Change}
              fieldTemplate={formTemplate[SELECT_ACOUNT_LEVEL2]}
              ref={arrRefs[SELECT_ACOUNT_LEVEL2]}
              noTranslateItems
              noTranslate={true}
              disabled={isEditMode}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              fullWidth
              margin='normal'
              data={data}
              value={accountLevel3}
              onKeyUp={handleAccountLevel3Change}
              fieldTemplate={formTemplate[SELECT_ACOUNT_LEVEL3]}
              ref={arrRefs[SELECT_ACOUNT_LEVEL3]}
              noTranslateItems
              noTranslate={true}
              disabled={isEditMode}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <div style={{ marginTop: '16px', marginBottom: '8px' }}>
              <MultiSelectWithCheckboxes
                id={'addCustomer_Applicablefor'}
                items={appOptions || []}
                defaultValue={exclusionType || []}
                fieldTemplate={formTemplate[APPLICABLE_FOR]}
                ref={arrRefs[APPLICABLE_FOR]}
                onChange={handleApplicableForChange}
                onClose={handleApplicableForChange}
                noTranslateItems
                noTranslate={true}
              />
            </div>
          </Grid>
          <Grid item xs={12} sm={4}>
            <FormControl fullWidth margin='normal'>
              <Select
                data={data}
                items={exclusionReasonOptions}
                onChange={handleExclusionReasonChange}
                fieldTemplate={formTemplate[EXCLUSION_REASON]}
                ref={arrRefs[EXCLUSION_REASON]}
                noTranslateItems
                noTranslate={true}
              />
            </FormControl>
          </Grid>
          {exclusionReason && exclusionReason.toLowerCase() === 'other' && (
            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                margin='normal'
                onChange={handleOtherReasonChange}
                inputProps={{ maxLength: 50 }}
                helperText={`${otherReasonLength}/${t('Search.fiftyCharacters')}`}
                fieldTemplate={formTemplate[OTHER_REASON]}
                ref={arrRefs[OTHER_REASON]}
                noTranslateItems
                noTranslate={true}
              />
            </Grid>
          )}
        </Grid>
      </DialogContent>
      <DialogActions>
        {errorMessage && (
          <Typography
            key={errorMessage}
            paragraph={true}
            style={{
              fontSize: '16px',
              color: '#FFF',
              backgroundColor: '#db4437',
              width: 'fit-content',
              padding: '4px',
              marginTop: '16px',
              flex: 0.96,
            }}
          >
            {errorMessage}
          </Typography>
        )}
        <Button onClick={handleClose} color='default'>
          {t('dialogs.cancel')}
        </Button>
        <Button
          onClick={handleValidate}
          color='primary'
          variant='contained'
          disabled={loading}
        >
        {loading ? (isEditMode ? t('buttons.updating') : t('buttons.adding')) : (isEditMode ? t('buttons.update') : t('buttons.add'))}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default AddCustomerModal